const TEXTURE_LIBRARY = "texture-library";

export const internalKeys = {
	textureLibrary: [TEXTURE_LIBRARY] as const,
};
